"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIconButtonSlots = exports.default = exports.IconButton = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _iconButtonClasses = require("./iconButtonClasses");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- many options */ var getIconButtonSlots = function(ownerState) {
    var color = ownerState.color, size = ownerState.size, variant = ownerState.variant, loading = ownerState.loading, edge = ownerState.edge;
    return {
        root: [
            'root',
            loading && 'loading',
            variant,
            "size".concat((0, _utils.capitalize)(size)),
            "color".concat((0, _utils.capitalize)(color)),
            (edge === 'end' || edge === 'start') && "edge".concat((0, _utils.capitalize)(edge))
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
};
exports.getIconButtonSlots = getIconButtonSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getIconButtonSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var IconButtonRoot = (0, _material.styled)(_material.ButtonBase, {
    name: 'MuiOriIconButton',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            styles["color".concat((0, _utils.capitalize)(ownerState.color))],
            styles["size".concat((0, _utils.capitalize)(ownerState.size))],
            ownerState.loading && styles.loading,
            (ownerState.edge === 'end' || ownerState.edge === 'start') && styles["edge".concat((0, _utils.capitalize)(ownerState.edge))]
        ];
    },
    shouldForwardProp: function(prop) {
        return (0, _utils.rootShouldForwardProp)(prop) || prop === 'classes';
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: '2.4rem',
        padding: 6,
        borderRadius: '50%',
        boxShadow: 'none',
        minHeight: 24,
        minWidth: 24,
        width: 'fit-content',
        height: 'fit-content',
        color: theme.palette.action.active,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        })
    }, ownerState.edge === 'start' && {
        marginLeft: -12
    }, ownerState.edge === 'end' && {
        marginRight: -12
    }, ownerState.size === 'small' && _object_spread({
        padding: 3,
        fontSize: '1.8rem'
    }, ownerState.edge === 'start' && {
        marginLeft: -3
    }, ownerState.edge === 'end' && {
        marginRight: -3
    }), ownerState.size === 'large' && {
        padding: 9,
        fontSize: '2.7rem'
    }, ownerState.variant === 'contained' && _object_spread({
        color: theme.palette.default.contrastText,
        background: theme.palette.default.dark,
        boxShadow: 'none',
        '&:hover': {
            color: theme.palette.default.contrastText,
            background: theme.palette.grey.A700,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: theme.palette.default.dark
            }
        },
        '&:focus': {
            color: theme.palette.default.contrastText
        }
    }, ownerState.disableFocusRipple && {
        '&:focus-visible': {
            color: theme.palette.default.contrastText,
            outline: "2px solid ".concat(theme.palette.common.white),
            outlineOffset: -4
        }
    }, ownerState.color === 'error' && {
        color: theme.palette.error.contrastText,
        background: theme.palette.error.main,
        '&:hover': {
            color: theme.palette.error.contrastText,
            background: theme.palette.error.dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: theme.palette.error.main
            }
        },
        '&:focus': {
            color: theme.palette.error.contrastText
        }
    }, ownerState.color === 'secondary' && {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
        '&:hover': {
            color: theme.palette.text.primary,
            backgroundColor: (0, _material.alpha)(theme.palette.default.main, 0.12),
            '@media (hover: none)': {
                backgroundColor: theme.palette.grey[100]
            }
        },
        '&:focus': {
            color: theme.palette.text.primary
        }
    }, (ownerState.disabled || ownerState.loading) && {
        background: theme.palette.grey[200],
        color: theme.palette.grey.A400
    }, ownerState.color === 'default' && _object_spread({
        color: theme.palette.default.main,
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[2],
        '&:hover': {
            color: theme.palette.default.main,
            background: theme.palette.default.contrastText,
            boxShadow: theme.shadows[3],
            '@media (hover: none)': {
                boxShadow: theme.shadows[2],
                background: theme.palette.default.contrastText
            }
        },
        '&:focus': {
            color: theme.palette.default.main
        },
        '&:focus-visible': {
            color: theme.palette.default.main,
            boxShadow: theme.shadows[6]
        }
    }, (ownerState.disabled || ownerState.loading) && {
        color: theme.palette.grey[400],
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[2]
    })), ownerState.variant === 'outlined' && _object_spread({
        padding: 4,
        border: '1px solid currentColor',
        borderColor: theme.palette.default.dark,
        color: theme.palette.default.dark,
        background: 'transparent',
        '&:hover': {
            color: theme.palette.default.dark,
            borderColor: theme.palette.default.dark,
            background: (0, _material.alpha)(theme.palette.default.main, 0.12),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: 'transparent'
            }
        },
        '&:focus': {
            color: theme.palette.default.dark
        },
        '&:active': {
            background: (0, _material.alpha)(theme.palette.default.main, 0.12)
        }
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor',
        '&:hover': {
            color: theme.palette.common.white,
            background: theme.palette.grey.A700,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                color: 'inherit',
                background: 'transparent'
            }
        },
        '&:active': {
            color: theme.palette.common.white,
            background: theme.palette.grey.A700
        }
    }, ownerState.color === 'error' && {
        borderColor: theme.palette.error.dark,
        color: theme.palette.error.dark,
        '&:hover': {
            color: theme.palette.error.dark,
            background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: 'transparent'
            }
        },
        '&:focus': {
            color: theme.palette.error.dark
        },
        '&:active': {
            background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
        }
    }, ownerState.color === 'secondary' && {
        borderColor: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
        background: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
        color: theme.palette.default.dark,
        '&:hover': {
            borderColor: (0, _material.alpha)(theme.palette.default.dark, 0.08),
            background: (0, _material.alpha)(theme.palette.default.dark, 0.08),
            color: theme.palette.default.dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderColor: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
                background: (0, _material.alpha)(theme.palette.default.contrastText, 0.75),
                color: theme.palette.default.dark
            }
        },
        '&:focus': {
            color: theme.palette.default.dark
        },
        '&:active': {
            background: (0, _material.alpha)(theme.palette.default.dark, 0.08)
        }
    }, ownerState.size === 'small' && {
        padding: 2
    }, ownerState.size === 'large' && {
        padding: 8
    }, (ownerState.disabled || ownerState.loading) && {
        background: theme.palette.grey[200],
        color: theme.palette.grey.A400,
        borderColor: theme.palette.grey[200]
    }, ownerState.disableFocusRipple && {
        '&:focus-visible': {
            outline: "2px solid ".concat(theme.palette.default.dark),
            outlineOffset: -2,
            backgroundColor: (0, _material.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }), ownerState.variant === 'text' && _object_spread({
        color: theme.palette.default.main,
        backgroundColor: 'transparent',
        '&:hover': {
            color: theme.palette.default.main,
            background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: 'transparent'
            }
        },
        '&:focus': {
            color: theme.palette.default.main
        },
        '&:active': {
            background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity)
        }
    }, ownerState.color === 'error' && {
        color: theme.palette.error.dark,
        '&:hover': {
            color: theme.palette.error.dark,
            background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                background: 'transparent'
            }
        },
        '&:focus': {
            color: theme.palette.error.dark
        },
        '&:active': {
            background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
        }
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        '&:hover': {
            color: theme.palette.common.white,
            background: theme.palette.grey.A700,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                color: 'inherit',
                background: 'transparent'
            }
        },
        '&:active': {
            color: theme.palette.common.white,
            background: theme.palette.grey.A700
        }
    }, (ownerState.disabled || ownerState.loading) && {
        background: 'transparent',
        color: theme.palette.grey.A400
    }, ownerState.disableFocusRipple && {
        '&:focus-visible': {
            outline: "1px solid ".concat(theme.palette.default.dark),
            outlineOffset: -1
        }
    }), ownerState.loading && {
        color: 'transparent'
    });
});
var IconButtonLoadingIndicator = (0, _material.styled)('span', {
    name: 'MuiOriIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.loadingIndicator
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread_props(_object_spread({
        display: 'none',
        position: 'absolute',
        visibility: 'visible'
    }, ownerState.loading && {
        display: 'flex'
    }), {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: theme.palette.action.disabled
    });
});
var getIcon = function(param) {
    var children = param.children, hoverIcon = param.hoverIcon, isHovering = param.isHovering;
    if (Boolean(hoverIcon) && isHovering) {
        return hoverIcon;
    }
    return children;
};
var IconButton = exports.IconButton = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriIconButton'
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, dataTestId = props.dataTestId, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, _props_edge = props.edge, edge = _props_edge === void 0 ? false : _props_edge, focusVisibleClassName = props.focusVisibleClassName, hoverIcon = props.hoverIcon, idProp = props.id, _props_loading = props.loading, loading = _props_loading === void 0 ? null : _props_loading, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, type = props.type, _props_variant = props.variant, variant = _props_variant === void 0 ? 'outlined' : _props_variant, other = _object_without_properties(props, [
        "children",
        "className",
        "color",
        "dataTestId",
        "disabled",
        "disableFocusRipple",
        "edge",
        "focusVisibleClassName",
        "hoverIcon",
        "id",
        "loading",
        "size",
        "type",
        "variant"
    ]);
    var loadingId = (0, _material.unstable_useId)(idProp);
    var loaderSize = (0, _react.useMemo)(function() {
        if (size === 'small') {
            return '1.4rem';
        }
        if (size === 'large') {
            return '2.3rem';
        }
        return '2rem';
    }, [
        size
    ]);
    var loadingIndicator = (0, _react.useMemo)(function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.CircularProgress, {
            "aria-labelledby": loadingId,
            color: "inherit",
            size: loaderSize
        });
    }, [
        loadingId,
        loaderSize
    ]);
    var _ref = _sliced_to_array((0, _react.useState)(false), 2), isHovering = _ref[0], setIsHovering = _ref[1];
    var handleMouseOver = (0, _react.useCallback)(function() {
        setIsHovering(true);
    }, []);
    var handleMouseOut = (0, _react.useCallback)(function() {
        setIsHovering(false);
    }, []);
    var ownerState = (0, _react.useMemo)(function() {
        return _object_spread_props(_object_spread({}, props), {
            color: color,
            disabled: disabled,
            disableFocusRipple: disableFocusRipple,
            edge: edge,
            size: size,
            type: type,
            variant: variant
        });
    }, [
        color,
        disabled,
        disableFocusRipple,
        edge,
        props,
        size,
        type,
        variant
    ]);
    var classes = useUtilityClasses(ownerState);
    var loader = (0, _react.useMemo)(function() {
        if (typeof loading === 'boolean') {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loadingIndicator
                }) : null
            });
        }
        return null;
    }, [
        classes.loadingIndicator,
        classes.loadingWrapper,
        loading,
        loadingIndicator,
        ownerState
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(IconButtonRoot, _object_spread_props(_object_spread({
        ref: ref,
        centerRipple: true,
        className: (0, _clsx.default)(classes.root, className),
        disabled: disabled || (loading !== null && loading !== void 0 ? loading : false),
        focusRipple: !disableFocusRipple,
        id: loading ? loadingId : idProp,
        "data-testid": dataTestId,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut
    }, other), {
        ownerState: ownerState,
        children: [
            loader,
            getIcon({
                children: children,
                hoverIcon: hoverIcon,
                isHovering: isHovering
            })
        ]
    }));
});
var _default = exports.default = IconButton; //# sourceMappingURL=IconButton.js.map
